import produce from 'immer';
import { createAction, handleActions } from 'redux-actions';

const MONTH_CHOICE_VALUE = 'common/MONTH_CHOICE_VALUE';
const YEAR_CHOICE_VALUE = 'common/YEAR_CHOICE_VALUE';
const CONCEPT_CHECK_PLAYER_POPUP = 'common/CONCEPT_CHECK_PLAYER_POPUP'
const APP_BACK_BTN_EVENT_DATA = 'common/APP_BACK_BTN_EVENT_DATA';

export const monthValueSelected = createAction(
  MONTH_CHOICE_VALUE,
  (item) => item
);

export const yearValueSelected = createAction(
  YEAR_CHOICE_VALUE,
  (item) => item
);

export const conceptCheckPlayerPopup = createAction(
  CONCEPT_CHECK_PLAYER_POPUP,
  (data) => data
);

export const setAppBackbtnEventData = createAction(
  APP_BACK_BTN_EVENT_DATA,
  (data) => data
);

const initialState = {
  monthValue: {label: '', data: ''},
  yearValue: null,
  conceptCheckPlayer: {
    url: '',
    title: '',
    stgCd: '',
    stepNm: '',
    thmaNm: '',
    onOff: false,
  },
  /**
   * android back button event관련 데이터
   */
  appBackBtnEventData: {
    pathname: '',  // 이전 url
    state: null, // 뒤로가기에 필요한 파라메타
    eventFunc: null,  // 뒤로가기 시 발생 시키고 싶은 callback 함수
  }
}

const common = handleActions(
  {
    [MONTH_CHOICE_VALUE]: (state, { payload: item }) =>  ({
      ...state,
      monthValue: item,
    }),
    [YEAR_CHOICE_VALUE]: (state, { payload: item }) => ({
      ...state,
      yearValue: item,
    }),
    [CONCEPT_CHECK_PLAYER_POPUP]: (state, { payload: data }) => {
      return ({
        ...state,
        conceptCheckPlayer: data
      })
    },
    [APP_BACK_BTN_EVENT_DATA]: (state, { payload: data }) => {
      return produce(state, draft => {
        draft.appBackBtnEventData = {
          ...state.appBackBtnEventData,
          ...data,
        }
      })
    }
  },
  initialState
);

export default common;
